import React from 'react'
import { Link } from 'react-router-dom'

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50">
      {/* Navigation */}
      <nav className="sticky top-0 bg-white/95 backdrop-blur shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <span className="text-2xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                NeuroTrain
              </span>
            </div>
            <div className="flex space-x-4">
              <Link to="/privacy" className="text-gray-700 hover:text-emerald-600 transition">
                Privacy Policy
              </Link>
              <Link to="/" className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-4 py-2 rounded-lg hover:shadow-lg transition">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Terms Content */}
      <section className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-3xl font-bold mb-6 text-gray-900">Terms and Conditions</h1>
          <p className="text-sm text-gray-600 mb-6">Effective Date: January 1, 2025 | Last Updated: January 1, 2025</p>
          
          <div className="space-y-6 text-gray-700">
            <div>
              <h2 className="text-xl font-semibold mb-3">1. Agreement to Terms</h2>
              <p className="mb-4">
                These Terms and Conditions ("Terms") constitute a legally binding agreement between you and PATAGON CONSULTING INC., 
                doing business as HELLO PROJECTS PRO ("Company," "we," "us," or "our"), concerning your access to and use of the 
                NeuroTrain call analysis platform and related services (the "Service").
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">2. Company Information</h2>
              <p className="mb-4">
                PATAGON CONSULTING INC.<br />
                DBA: HELLO PROJECTS PRO<br />
                18546 SHERMAN WAY STE 103<br />
                RESEDA, CA 91335<br />
                Phone: (888) 706-0080<br />
                Email: hello@patagonusa.com<br />
                BBB Accredited Business with A+ Rating
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">3. Service Description</h2>
              <p className="mb-4">
                NeuroTrain provides AI-powered call analysis and transcription services for businesses in various industries including 
                home improvement, insurance, healthcare, and customer service. Our Service includes:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Call transcription and analysis</li>
                <li>Performance evaluation and scoring</li>
                <li>Custom business analysis templates</li>
                <li>Audio transcription services</li>
                <li>Analytics and reporting tools</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">4. TCPA Compliance</h2>
              <p className="mb-4">
                In accordance with the Telephone Consumer Protection Act (TCPA), we affirm that:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Our Service is designed to help businesses comply with TCPA regulations</li>
                <li>Users are responsible for obtaining proper consent before recording calls</li>
                <li>All call recordings must comply with federal and state two-party consent laws where applicable</li>
                <li>We do not initiate calls or send automated messages on behalf of users</li>
                <li>Users must maintain their own TCPA compliance procedures</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">5. Subscription and Payment</h2>
              <p className="mb-4">
                <strong>5.1 Subscription Plans:</strong><br />
                Professional Plan: $4.99/month<br />
                • 100 analyses per month<br />
                • All call types<br />
                • Full analytics access<br />
                • Email support
              </p>
              <p className="mb-4">
                <strong>5.2 Free Trial:</strong><br />
                New users receive a 7-day free trial with limited features (3 analyses).
              </p>
              <p className="mb-4">
                <strong>5.3 Billing:</strong><br />
                Subscriptions are billed monthly in advance. Payment processing is handled securely through Stripe.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">6. User Responsibilities</h2>
              <ul className="list-disc pl-6 mb-4">
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Comply with all applicable laws regarding call recording and privacy</li>
                <li>Obtain necessary consents before uploading call recordings</li>
                <li>Use the Service only for lawful business purposes</li>
                <li>Not attempt to reverse engineer or compromise the Service</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">7. Intellectual Property</h2>
              <p className="mb-4">
                The Service and its original content, features, and functionality are owned by PATAGON CONSULTING INC. and are 
                protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">8. Limitation of Liability</h2>
              <p className="mb-4">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, PATAGON CONSULTING INC. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
                SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">9. Dispute Resolution</h2>
              <p className="mb-4">
                <strong>9.1 Arbitration:</strong> Any disputes shall be resolved through binding arbitration in accordance with 
                the American Arbitration Association rules.<br />
                <strong>9.2 Governing Law:</strong> These Terms shall be governed by the laws of the State of California.<br />
                <strong>9.3 Venue:</strong> Any legal proceedings shall be brought in Los Angeles County, California.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3">10. Contact Information</h2>
              <p className="mb-4">
                For questions, suggestions, or complaints regarding these Terms, please contact us at:<br />
                Email: hello@patagonusa.com<br />
                Phone: (888) 706-0080<br />
                Mail: 18546 Sherman Way Ste 103, Reseda, CA 91335
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 mb-2">© 2025 PATAGON CONSULTING INC. All rights reserved.</p>
          <p className="text-gray-400 text-sm">
            DBA Hello Projects Pro | 18546 Sherman Way Ste 103, Reseda, CA 91335
          </p>
        </div>
      </footer>
    </div>
  )
}

export default TermsPage
